import * as React from "react";
import Button from "./Button";
import useConfig from "../hooks/useConfig";

interface CloseChatFormProps {
  onClose: () => void;
}

export default function CloseChatForm(props: CloseChatFormProps) {
  const config = useConfig();
  return (
    <div className="velaro-close-chat-form">
      <Button variant="danger" onClick={() => props.onClose()}>
        {config.CloseChatButtonText}
      </Button>
    </div>
  );
}
